import { Injectable } from '@angular/core';
import { AngularFireAuth } from "@angular/fire/auth";
import * as firebase from 'firebase';
import * as firebaseui from 'firebaseui';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class AuthService {

  allowLogin = false;

  uiShown = new Subject<boolean>();
  uiShown$ = this.uiShown.asObservable();

  user = new Subject<firebase.default.User>();
  user$ = this.user.asObservable();

  _user : firebase.default.User;
  authChecksFinished: boolean = false;

  accessToken: any;
  public ui: firebaseui.auth.AuthUI;

  constructor(
    public afAuth: AngularFireAuth, // Inject Firebase auth service
  ) {
    this.afAuth.authState.subscribe(user => {
      this.fixUser(user);
    })
  }

  firebaseuiStart(){
    var _uiShown = this.uiShown;
    var allowLogin = this.allowLogin;

    if (!this.ui) this.ui = new firebaseui.auth.AuthUI(firebase.default.auth());
    var uiConfig = {
      callbacks: {
        signInSuccessWithAuthResult: function(authResult, redirectUrl) {
          // User successfully signed in.
          // Return type determines whether we continue the redirect automatically
          // or whether we leave that to developer to handle.
          var user = authResult.user;
          if (authResult.additionalUserInfo.isNewUser)
          {
              user.sendEmailVerification();
          }
          allowLogin=false;
          return true;
        },
        uiShown: function() {
          // The widget is rendered.
          _uiShown.next(true);
        }
      },
      // Will use popup for IDP Providers sign-in flow instead of the default, redirect.
      signInFlow: 'popup',
      signInSuccessUrl: window.location.href,
      signInOptions: [
        firebase.default.auth.EmailAuthProvider.PROVIDER_ID,
      ],
    };

    // The start method will wait until the DOM is loaded.
    this.ui.start('#firebaseui-auth-container', uiConfig);
  }

  SignOut() {
    this.afAuth.signOut().then(() => {
      this._user = null;
      this.accessToken = null;
      window.location.reload();
    })
  }

 

  fixUser(user: firebase.default.User){
    if (user) {
      user.getIdToken().then(_accessToken =>{
        this.accessToken = _accessToken;
        this._user = user;
        this.authChecksFinished = true;
        this.user.next(user);
      });
    }
    else {
      this.authChecksFinished = true;
      this.user.next(user);
    }
  }

  showLogin(){
    this.allowLogin = true;
  }

  hideLogin() {
    this.allowLogin = false;
  }
}

